import { useContext, useEffect, useState } from 'react'
import { GenericHeaderBackButton } from 'src/consumer/components/ActivityPlansPage/MyPlanComponents'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { MentorClinicsContext } from 'src/mentor/layout'
import { getMPDataWithParams } from 'src/mentor/services'
import { AvailabilityPageContainer } from '../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import MentorHeader from '../MentorHeader'
import FeeModelsDisplay from './components/FeeModelsDisplay'

export default function ActiveFeeModels() {
  const { associatedClinicBrands, associatedClinicsData, loadingAssociationsData } =
    useContext(MentorClinicsContext)

  const [selectedClinicBrandId, setSelectedClinicBrandId] = useState()

  useEffect(() => {
    if (associatedClinicBrands && associatedClinicBrands?.length > 0) {
      setSelectedClinicBrandId(associatedClinicBrands?.[0]?.id)
    }
  }, [associatedClinicBrands])

  const [loading, setLoading] = useState(false)
  const [entityFeeModels, setEntityFeeModels] = useState()
  const [inApplicableEntityFeeModels, setInApplicableEntityFeeModels] = useState()
  const [feeModels, setFeeModels] = useState()
  const [feeModelGroups, setFeeModelGroups] = useState()
  async function getFeeModels() {
    const resp = await getMPDataWithParams('/api/secure/clinic-admin/entity-fee-model/list', {
      clinicBrandId: selectedClinicBrandId?.id,
    })
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const data = getDataMapFromCommonResponse(resp)
        setEntityFeeModels(data?.['entity-fee-model'])
        setInApplicableEntityFeeModels(data?.['inApplicable__entity-fee-model'])
        setFeeModels(data?.['fee-model'])
      }
    }
  }

  async function getFeeModelGroups(){
    const resp = await getMPDataWithParams(
      '/api/secure/clinic-admin/fee-model-group/list',
    )
    if(resp.status === 200){
      if(isCommonResponseSuccessfulV2(resp)){
        const data = getDataMapFromCommonResponse(resp)
        setFeeModelGroups(data?.['fee-model-group'])
      }
    }
  }

  async function setup() {
    setLoading(true)
    await getFeeModels()
    await getFeeModelGroups()
    setLoading(false)
  }

  useEffect(() => {
    if (selectedClinicBrandId) {
      setup()
    }
  }, [selectedClinicBrandId])

  useEffect(() => {
    if (associatedClinicBrands) {
      setSelectedClinicBrandId(associatedClinicBrands?.[0])
    }
  }, [associatedClinicBrands])

  console.log({ feeModels, entityFeeModels, inApplicableEntityFeeModels, feeModelGroups })

  return (
    <AvailabilityPageContainer>
      <MentorHeader showBackButton heading="Business Models for fee collected from Patients" />
      <GenericHeaderBackButton
        clickfunction={() => window.history.back()}
        styles={{ margin: '20px' }}
      />
      <FeeModelsDisplay
        entityFeeModels={entityFeeModels}
        inApplicableEntityFeeModels={inApplicableEntityFeeModels}
        feeModels={feeModels}
        feeModelGroups={feeModelGroups}
        forMentor={false}
        loading={loading}
      />
    </AvailabilityPageContainer>
  )
}
